import { ContextType } from 'react';

export const AlertsConstants = {
  LoadAllIncidents: 'ALERTS_CONSTANT.LOAD_ALL_INCIDENTS',
  LoadAllAlerts: 'ALERTS_CONSTANT.LOAD_ALL_ALERTS',
  LoadAllSubscribers: 'ALERTS_CONSTANT.LOAD_ALL_SUBSCRIBERS',
  AddSubscriber: 'ALERTS_CONSTANT.ADD_SUBSCRIBER',
  RemoveSubscriber: 'ALERTS_CONSTANT.REMOVE_SUBSCRIBER',
  SetRegisterSlugs: 'ALERTS_CONSTANT.SET_REGISTER_SLUGS',
  SetSubscribers: 'ALERTS_CONSTANT.SET_SUBSCRIBERS',
  SetAlertsError: 'ALERTS_CONSTANT.SET_ALERTS_ERROR',
  ClearAlertsError: 'ALERTS_CONSTANT.CLEAR_ALERTS_ERROR',
  SetSelectedIncident: 'ALERTS_CONSTANT.SET_SELECTED_INCIDENT',
  StartLoading: 'ALERTS_CONSTANT.START_LOADING',
  FinishLoading: 'ALERTS_CONSTANT.FINISH_LOADING',
  StartLoadingIncident: 'ALERTS_CONSTANT.START_LOADING_INCIDENT',
  FinishLoadingIncident: 'ALERTS_CONSTANT.FINISH_LOADING_INCIDENT',
  CreateAlertConditionSuccess: 'ALERTS_CONSTANT.CREATE_ALERT_CONDITION_SUCCESS',
  ClearCreateAlertConditionSuccess: 'ALERTS_CONSTANT.CLEAR_CREATE_ALERT_CONDITION_SUCCESS',
  EditAlertConditionSuccess: 'ALERTS_CONSTANT.EDIT_ALERT_CONDITION_SUCCESS',
  ClearEditAlertConditionSuccess: 'ALERTS_CONSTANT.CLEAR_EDIT_ALERT_CONDITION_SUCCESS',
  UpdateAlertSuccess: 'ALERTS_CONSTANT.UPDATE_ALERT_SUCCESS',
  FetchAlert: 'ALERTS_CONSTANT.FETCH_ALERT',
};

// ACTION Types
interface LoadAllAlertsAction {
  type: typeof AlertsConstants.LoadAllAlerts;
  payload: AlertConditionType[];
}

interface FetchAlertAction {
  type: typeof AlertsConstants.FetchAlert;
  payload: AlertType;
}

interface LoadAllIncidentsAction {
  type: typeof AlertsConstants.LoadAllIncidents;
  payload: IncidentListType;
}

interface SetSelectedIncidentAction {
  type: typeof AlertsConstants.SetSelectedIncident;
  payload: AlertConditionType;
}

interface SetRegisterSlugsAction {
  type: typeof AlertsConstants.SetRegisterSlugs;
  payload: RegisterSlugType[];
}

interface CreateAlertConditionSuccessAction {
  type: typeof AlertsConstants.CreateAlertConditionSuccess;
  payload: undefined;
}

interface ClearCreateAlertConditionSuccessAction {
  type: typeof AlertsConstants.ClearCreateAlertConditionSuccess;
  payload: undefined;
}

interface SetAlertsErrorAction {
  type: typeof AlertsConstants.SetAlertsError;
  payload: string;
}

export type AlertsActionTypes =
  | LoadAllAlertsAction
  | LoadAllIncidentsAction
  | SetSelectedIncidentAction
  | SetRegisterSlugsAction
  | CreateAlertConditionSuccessAction
  | ClearCreateAlertConditionSuccessAction
  | SetAlertsErrorAction
  | FetchAlertAction;

// STATE slices
export interface AlertConditionType {
  name: string;
  uid_hash: string;
  data_point_tag: string;
  is_active: boolean;
  limit_range_lower: string;
  limit_range_upper: string;
  schedule_end_date: string;
  schedule_start_date: string;
  alert_type: string;
  severity_level: string;
  range_type: string;
  rolling_average_minutes: number;
  threshold: number;
  deactivate_until: string;
  first_incident_timestamp: string;
  last_incident_timestamp: string;
  api_location: string;
}

export interface AlertListType {
  count: number;
  previous: string | null;
  next: string | null;
  results: AlertType[];
}

export interface AlertType {
  uid_hash: string;
  name: string;
  message: string;
  description: string;
  alert_type: string;
  severity_level: string;
  is_active: boolean;
  schedule_start_date: string | null;
  schedule_end_date: string | null;
  threshold: string;
  auto_resolve_threshold: string;
  subscriber_update_api_location: string;
  context_api_location: string;
  condition_api_location: string;
}

export interface SubscriberType {
  user: number;
  first_name: string;
  last_name: string;
  name: string;
  email: string;
  phone_number: string;
}

export interface AlertSubscriptionType {
  subscriber: SubscriberType;
  method: string;
}

export interface IncidentListType {
  count: number;
  previous: string | null;
  next: string | null;
  results: IncidentType[];
}

export interface IncidentType {
  uid_hash: string;
  building_identifier: string;
  api_location: string;
  comments_count: number;
  event_count: number;
  is_resolved: boolean;
  last_seen_timestamp: string;
  name: string;
  resolution_api_location: string;
  severity: string;
}

export interface IncidentV2Type {
  name: string;
  last_seen_timestamp: string;
  severity: string;
  is_resolved: boolean;
  event_count: number;
  comments_count: number;
  comments: CommentType[];
  recent_failures: string;
  api_location: string;
  resolution_api_location: string;
  previous_incidents: string;
  context_api_location: string;
  comments_api_location: string;
  context_data_api_location: string;
}

export interface CommentType {
  created: string;
  user: string;
  comment: string;
  uid_hash: string;
  api_location: string;
}

export interface RegisterSlugType {
  slug: string;
  name: string;
  legacy_slug: string;
  data_point_tag: string;
  measurement_unit: string;
  measurement_unit_display: string;
}

export interface AlertAdminFilterType {
  name: string;
  is_snoozed: boolean;
  status: string[];
}

interface GraphDataSetType {
  timestamp: string;
  occurences: number;
}

export interface AlertsReducer {
  allAlerts: AlertConditionType[];
  allIncidents: IncidentListType;
  selectedIncident: IncidentV2Type;
  numberOfFilters: number;
  alertAdminFilters: AlertAdminFilterType;
  registerSlugs: RegisterSlugType[];
  subscribers: SubscriberType[];
  alertConditionCreated: boolean;
  alertConditionEdited: boolean;
  alertsError: string;
  isLoading: boolean;
  isLoadingIncident: boolean;
}
